<template>
  <ViolationForm :is-new="false" />
</template>
<script>
import ViolationForm from './ViolationForm.vue'

export default {
  components: { ViolationForm },
}
</script>
